<ngx-json-ld
  [json]='{
  "@context": "http://schema.org",
  "@type": "product",
  "name": "Bruiloft in je Broekzak",
  "logo": "https://bruiloftinjebroekzak.nl/assets/images/logos/logo-bijb-small.png",
  "url": "https://bruiloftinjebroekzak.nl",
  "image": "https://bruiloftinjebroekzak.nl/assets/images/mockups/mockup-welcome-small.png",
  "category": "Apps",
  "description": "De meest complete app voor jullie bruiloftsgasten. Alle informatie in 1 app.",
  "aggregateRating": {
    "@type": "aggregateRating",
    "ratingValue": "4.8",
    "reviewCount": "134"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "EUR",
    "price": originalPrice,
    "priceValidUntil": "2036-01-01",
    "availability": "http://schema.org/InStock",
    "seller": {
      "@type": "Organization",
      "name": "Bruiloft in je Broekzak"
    }
  }
  }'></ngx-json-ld>

<div id="app">
  <app-storefront-banner></app-storefront-banner>
  <div class="content" [class.error-page]="isErrorPage">
    <app-error-modal></app-error-modal>
    <router-outlet (activate)="onRouterOutletActivate()"></router-outlet>
  </div>
  <div id="footer">
    <div class="footer-content">
      <div class="faq-button">
        <!--<button class="button button-wide" [routerLink]="['/', 'static', 'faq']">Vragen?</button>-->
      </div>

      <div class="logo-icon">
        <img src="/assets/images/logos/bijb-icon-small.png">
      </div>

      <div class="links">

      <ul class="legal-links">
        <h3>Sitemap</h3>
        <li><a routerLink="/contact">Contact</a></li>
        <li><a routerLink="/static/privacy-policy-nl">Privacybeleid</a></li>
        <li><a routerLink="/static/end-user-agreement-nl">Gebruiksvoorwaarden</a></li>
        <li><a routerLink="/static/terms-conditions-nl">Algemene Voorwaarden</a></li>
      </ul>

      <ul class="social-links mobile-menu">
        <h3>Volg ons!</h3>
        <li class="social-link-list-item">
          <a href="https://www.facebook.com/bruiloftinjebroekzak/" target="_blank">
            <fa-icon [icon]="['fab', 'facebook']"></fa-icon>
          </a>
        </li>
        <li class="social-link-list-item">
          <a href="https://www.instagram.com/bruiloftinjebroekzak/" target="_blank">
            <fa-icon [icon]="['fab', 'instagram']"></fa-icon>
          </a>
        </li>
      </ul>
    </div>


    </div>
  </div>
</div>
